import React, { useState, useEffect } from 'react';
import { Container, Card, Row, Col, Form, Alert } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { Circles } from 'react-loader-spinner'; // Ensure this is the correct loader component
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formFields, fileFields } from './EditProfileConfig.js';
import service from '../../services/service.js';
import './EditProfile.css';
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { TokenCertificateImageinModel, TokenIDImageinModel, TokenImageinModel } from "../../app/basic-ui/TokenImage.js";

const EditProfile = (props) => {

  // useEffect(() => {
  //   let token = UserService.generateToken();
  // }, []);

  // console.log("props", props.id);

  let id = props.id;

  const { t } = useTranslation();
  const history = useHistory();

  const [allCountries, setAllCountries] = useState([]);
  const [allStates, setAllStates] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [allNationalities, setAllNationalities] = useState([]);
  const [allQualifications, setAllQualifications] = useState([]);
  const [allDesignations, setAllDesignations] = useState([]);
  const [allOrganizations, setAllOrganizations] = useState([]);


  const [formData, setFormData] = useState({});
  const [fileData, setFileData] = useState({});
  const [getProfileStatus, setProfileStatus] = useState();
  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState({ show: false, message: '', type: '' });
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [PhotoLoading, setPhotoLoading] = useState({
    isLoading: false
  })
  const [IDLoading, setIDLoading] = useState({
    isLoading: false
  })
  const [CertificateLoading, setCertificateLoading] = useState({
    isLoading: false
  })
  const [getViewPhoto, setViewPhoto] = useState({
    show: false
  });
  const [getViewCertificate, setViewCertificate] = useState({
    show: false
  });
  const [getViewID, setViewID] = useState({
    show: false
  });

  const [fieldStates, setFieldStates] = useState({
    otherCountryVisible: false,
    // instituteNameVisible: false //// INITIAL STATE WILL BE NOT VIDIBLE
  });




  useEffect(() => {
    fetchUserDetails();
    getAllCountry();
    getAllStates();
    // getAllCategories();
    // getAllNationalities();
    getAllQualifications();
    getAllDesignations();
    fetchLearnersFileDetails();
    // getAllOrganizations();

  }, [id]);

  const fetchUserDetails = () => {
    service.getUserProfileById(id)
      .then((response) => {
        setFormData(response.data);
        setProfileStatus(response.data.status);
      })
      .catch((err) => {
        console.error('Error fetching profile data:', err);
      });
  }

  const fetchLearnersFileDetails = () => {
    service.getLearnersFileDetails(id)
      .then((response) => {
        setFileData(response.data);
      })
      .catch((err) => {
        console.error('Error fetching profile data:', err);
      });
  }

  const viewPhoto = (profilepicpath, email, learnername, imagepath) => {
    //console.log(profilepicpath, learnername, imagepath)
    setPhotoLoading({ isLoading: true });
    setViewPhoto({
      show: true,
      learnername: learnername,
      imagepath: imagepath,
      profilepicpath: profilepicpath,
    });
  }

  const viewID = (idproofpicpath, email) => {
    setIDLoading({ isLoading: true });
    setViewID({
      show: true,
      idproofpicpath: idproofpicpath,
    });
  }

  const viewCertificate = (certificatepath, email) => {
    setCertificateLoading({ isLoading: true });
    setViewCertificate({
      show: true,
      certificatepath: certificatepath,
    });
  }

  const CertificateHide = () => {
    setViewCertificate({ show: false });
    setCertificateLoading({ isLoading: false });
    //setInfoLoading({ isLoading: false });
  }
  const IDCardHide = () => {
    setViewID({ show: false });
    setIDLoading({ isLoading: false });
    //setInfoLoading({ isLoading: false });
  }

  const ProfilePicHide = () => {
    setViewPhoto({ show: false });
    setPhotoLoading({ isLoading: false });
    //setInfoLoading({ isLoading: false });
  }


  const handleFormInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    const error = validateFormField(name, value);
    setErrors(prev => ({ ...prev, [name]: error }));

    // Iterate over form fields to check dependencies and update field states
    formFields.forEach((field) => {
      // Handle enabled dependencies
      if (field.enabledDependencies && field.enabledDependencies.field === name) {
        const shouldEnable = field.enabledDependencies.condition(value);
        setFieldStates((prev) => ({
          ...prev,
          [`${field.name}Disabled`]: !shouldEnable,
        }));
      }

      // Handle visibility dependencies
      if (field.visibilityDependencies && field.visibilityDependencies.field === name) {
        const shouldShow = field.visibilityDependencies.condition(value);
        setFieldStates((prev) => ({
          ...prev,
          [`${field.name}Visible`]: shouldShow,
        }));
      }

      // Handle requireDependencies
      if (field.requireDependencies && field.requireDependencies.field === name) {
        const shouldRequire = field.requireDependencies.condition(value);

        setFieldStates((prev) => ({
          ...prev,
          [`${field.name}Required`]: shouldRequire,
        }));

        // Validate the field if it becomes required
        if (shouldRequire) {
          const validationError = validateFormField(
            field.name,
            formData[field.name] || ''
          );
          setErrors((prev) => ({ ...prev, [field.name]: validationError }));
        } else {
          // Clear errors if the field is no longer required
          setErrors((prev) => ({ ...prev, [field.name]: null }));
        }
      }
    });
  };

  const getAllCountry = () => {
    setPageLoading(true);
    service.getCountry()
      .then((res) => {
        setAllCountries(res?.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load Country Data", "error");
      })
  }

  const getAllStates = () => {
    setPageLoading(true);
    service.getState()
      .then((res) => {
        setAllStates(res?.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load States Data", "error");
      })
  }

  const getAllNationalities = () => {
    setPageLoading(true);
    service.getAllUserNationality()
      .then((res) => {
        setAllNationalities(res?.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load States Data", "error");
      })
  }

  const getAllQualifications = () => {
    setPageLoading(true);
    service.RegisterQualification()
      .then((res) => {
        setAllQualifications(res?.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load Qualification Data", "error");
      })
  }

  const getAllDesignations = () => {
    setPageLoading(true);
    service.RegisterDesignation()
      .then((res) => {
        setAllDesignations(res.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load Qualification Data", "error");
      })
  }

  const getAllOrganizations = () => {
    setPageLoading(true);
    service.getAllOrganizations()
      .then((res) => {
        setAllOrganizations(res.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load Qualification Data", "error");
      })
  }

  const getAllCategories = () => {
    setPageLoading(true);
    service.getAllUserCategory()
      .then((res) => {
        setAllCategories(res?.data);
        setPageLoading(false);
      }).catch((err) => {

        setPageLoading(false);
        // swal(t('error'), "Failed to load States Data", "error");
      })
  }

  //console.log("errors -> ", errors)



  const handleFileChange = (event) => {
    // console.log(event.target);
    const { name, files } = event.target;
    const file = files[0];
    const field = fileFields.find((field) => field.name == name);

    // console.log(field);

    if (!file) {
      setErrors((prev) => ({ ...prev, [name]: "File is required." }));
      return;
    }

    // Validate file size
    if (file.size > field.maxSize) {
      setErrors((prev) => ({
        ...prev,
        [name]: `File size exceeds the limit of ${field.maxSize / (1024)} KB.`,
      }));
      return;
    }

    // Validate file type
    if (!field.accept.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        [name]: `Invalid file type. Allowed types: ${field.accept.join(", ")}.`,
      }));
      return;
    }

    // Clear any previous errors
    setErrors((prev) => ({ ...prev, [name]: null }));

    // Update the form data
    setFileData((prev) => ({
      ...prev,
      [name]: file,
    }));
  };

  const validateFormField = (name, value) => {
    const field = formFields.find((f) => f.name === name);
    if (!field) return null;

    // If the field is required, validate for non-empty value
    if ((fieldStates[`${name}Required`] || field.required)) {
      if (field.type === 'file' && (!value || value.length === 0)) {
        return `${field.label} is required`;
      }

      if (field.type === 'select' && (!value || value === '')) {
        return `${field.label} is required`;
      }

      if (typeof value === 'string' && value.trim() === '') {
        return `${field.label} is required`;
      }
    }

    // If the field is not required but has a value, validate the regex
    if (value && field.validation?.regex && !field.validation.regex.test(value)) {
      return field.validation.errorMessage;
    }

    if (field.validation?.custom && !field.validation.custom(value)) {
      return field.validation.errorMessage;
    }

    // No validation errors
    return null;
  };

  const validateFileField = (name, value) => {
    const field = fileFields.find((f) => f.name === name);
    if (!field) return null;

    // If the field is required, validate for non-empty value
    if ((fieldStates[`${name}Required`] || field.required)) {

      if (field.type === 'file' && (!value || value.length === 0)) {
        return `${field.label} is required`;
      }

      if (field.type === 'select' && (!value || value === '')) {
        return `${field.label} is required`;
      }

      if (typeof value === 'string' && value.trim() === '') {
        return `${field.label} is required`;
      }
    }

    // If the field is not required but has a value, validate the regex
    if (value && field.validation?.regex && !field.validation.regex.test(value)) {
      return field.validation.errorMessage;
    }

    if (field.validation?.custom && !field.validation.custom(value)) {
      return field.validation.errorMessage;
    }

    // No validation errors
    return null;
  };

  const handleAdminSubmit = () => {
    setPageLoading(true);
    setSubmitLoading(true)
    const form = new FormData();
    form.append("userId", formData.learnerUsername)
    service.requestAdmintoApproveProfile(form).then((res => {
      setSubmitLoading(false)
      //console.log(res.data);
      fetchUserDetails();
      setPageLoading(false);
    })).catch(err => {
      fetchUserDetails();
      setSubmitLoading(false)
      setPageLoading(false);
    })
  }

  const handleFileSubmit = (e) => {
    e.preventDefault();

    const validationErrors = {};

    Object.keys(fileData).forEach((field) => {
      //console.log(field, fileData[field]);
      const error = validateFileField(field, fileData[field]);
      if (error) validationErrors[field] = error;
    });

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setSubmitStatus({
        show: true,
        message: 'Please fix the errors and try again.',
        type: 'danger'
      });
      return;
    }

    setLoading(true);
    setPageLoading(true);

    const jsonPayload = { ...fileData };

    //console.log("jsonPayload -> ", jsonPayload)

    const formDataObj = new FormData();

    if (fileData.profilepicpath instanceof File) {
      formDataObj.append("profilepicpath", fileData.profilepicpath);
    }
    if (fileData.idproofpicpath instanceof File) {
      formDataObj.append("idproofpicpath", fileData.idproofpicpath);
    }
    if (fileData.certificatepath instanceof File) {
      formDataObj.append("certificatepath", fileData.certificatepath);
    }
    formDataObj.append("userId", formData.learnerUsername);

    service.updateUserFiles(formDataObj).then((res => {
      setLoading(false);
      setPageLoading(false);
      // console.log(res.data);
      fetchLearnersFileDetails();

    })).catch(err => {

      setLoading(false);
      setPageLoading(false);

    })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = {};

    // Validate each field and store errors in validationErrors
    Object.keys(formData).forEach((field) => {
      const error = validateFormField(field, formData[field]);
      if (error) validationErrors[field] = error;
    });


    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setSubmitStatus({
        show: true,
        message: 'Please fix the errors and try again.',
        type: 'danger'
      });
      return;
    }

    setLoading(true);
    setPageLoading(true);

    // Create a FormData object for multipart/form-data
    // const formDataToSend = new FormData();
    // Object.keys(formData).forEach((key) => {
    //   formDataToSend.append(key, formData[key]);
    // });
    const jsonPayload = { ...formData };
    // Ensure service.EditProfile sends data as multipart


    service.updateUser(jsonPayload)
      .then(async (response) => {
        if (response.status === 200) {
          setLoading(false);
          setPageLoading(false);
          Swal.fire({
            title: t("success_swal"),
            text: t("profile_update_success_desc"),
            icon: "success",
            showConfirmButton: false,
            timer: 10000,
          }).then(() => {
            // history.push("/");
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        setPageLoading(false);
        // console.log("ERROR ====>", err);

        if (err.response && err.response.data) {
          const { status, data } = err.response;
          if (status >= 400 && status < 500) {
            Swal.fire(t("warning"), data.message || data, "warning")
          } else {
            Swal.fire(t("error"), t("unexpected_error_message"), "error")
          }
        } else {
          Swal.fire(t("error"), t("network_error"), "error")
        }
      });
  };

  const groupedFields = formFields.reduce((groups, field) => {
    const { row = 1 } = field;
    if (!groups[row]) groups[row] = [];
    groups[row].push(field);
    return groups;
  }, {});

  const groupedfileFields = fileFields.reduce((groups, field) => {
    const { row = 1 } = field;
    if (!groups[row]) groups[row] = [];
    groups[row].push(field);
    return groups;
  }, {});

  const setProfileStatusFlag = () => {
    //console.log(getProfileStatus)
    if (getProfileStatus == null) {
      return false;
    }
    else if (getProfileStatus == "req-to-update") {
      return true;
    }
    else if (getProfileStatus == "emailverified" && formData?.registrationType == 1) {
      return true;
    }
    else {
      return false;
    }
  }

  return (
    <div className="edit-profile-page">
      {pageLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.7)', // Adjust the transparency as needed
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000, // Ensure it's above other elements
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Circles height={40} width={40} color="#4fa94d" ariaLabel="circles-loading" />
          </div>
        </div>
      )}

      <Container fluid className="edit-profile-area">
        <Card className="edit-profile-card">
          <Card.Header className="text-center border-0 bg-transparent pt-4">
            <div className="edit-profile-title">
              <h2>Update Profile</h2>
            </div>
          </Card.Header>
        </Card>
        <Card className="edit-profile-card">
          {/* <Card.Header className="text-center border-0 bg-transparent pt-4">
            <div className="edit-profile-title">
              <h2>Update Profile</h2>
            </div>
          </Card.Header> */}
          <Card.Body className="px-4 py-4">
            {submitStatus.show && (
              <Alert
                variant={submitStatus.type}
                onClose={() => setSubmitStatus({ ...submitStatus, show: false })}
                dismissible
                className="mb-4"
              >
                {submitStatus.message}
              </Alert>
            )}

            <Form>
              {Object.entries(groupedFields).map(([row, fields]) => (
                <Row key={row} className="mb-3">
                  {fields.map((field) => {
                    const isVisible = fieldStates[`${field.name}Visible`] !== false; // Default is true unless explicitly set to false
                    const isDisabled = fieldStates[`${field.name}Disabled`] === true;

                    return (
                      isVisible && (
                        <Col key={field.name} md={field.col || 6} sm={12}>
                          <Form.Group className="form-group">
                            <div className="d-flex align-items-center">
                              <Form.Label className="form-label mb-0">
                                {t(field.label)}
                                {field.required && <span className="text-danger">*</span>}
                              </Form.Label>
                              {field.infoTop && (
                                <div className="field-top-info ms-3">
                                  <p className="text-muted mb-0">{field.infoTop.message}</p>
                                  {field.infoTop.link && (
                                    <a
                                      href={field.infoTop.link.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="d-block text-primary mt-1"
                                    >
                                      {field.infoTop.link.text}
                                    </a>
                                  )}
                                </div>
                              )}
                            </div>
                            {field.type === "file" ? (
                              <Form.Control
                                className={`form-media ${field.isDisabled ? 'disabled' : ''}`}
                                type="file"
                                name={field.name}
                                accept={field.accept.join(",")}
                                // onChange={handleFileChange}
                                isInvalid={!!errors[field.name]}
                                disabled={field.isDisabled}
                              />
                            ) : field.type === 'select' ? (
                              <Form.Select
                                className={`form-select ${field.isDisabled ? 'disabled' : ''}`}
                                name={field.name}
                                value={formData[field.name] || ''}
                                onChange={handleFormInputChange}
                                isInvalid={!!errors[field.name]}
                                disabled={field.isDisabled}
                              >
                                <option value="">{`Select ${field.label}`}</option>

                                {(() => {
                                  // Select the correct array of options based on the field name
                                  const options =
                                    field.name === 'qualId' ? allQualifications :
                                      field.name === 'userNationality' ? allNationalities :
                                        field.name === 'userCategory' ? allCategories :
                                          field.name === 'desgId' ? allDesignations :
                                            field.name === 'countryId' ? allCountries :
                                              field.name === 'stateId' ? allStates :
                                                field.name === 'orgId' ? allOrganizations :
                                                  field.options; // Fallback for static options if available

                                  // Render the options with appropriate label and value fields
                                  return options.map((option, index) => (
                                    <option
                                      key={index}
                                      value={
                                        option.qualId ||
                                        option.userNationalityId ||
                                        option.userCategoryId ||
                                        option.desgId ||
                                        option.countryId ||
                                        option.stateId ||
                                        option.orgId ||
                                        option.value ||
                                        option
                                      }
                                    >
                                      {option.qualification ||
                                        option.userNationalityName ||
                                        option.userCategoryName ||
                                        option.designation ||
                                        option.countryName ||
                                        option.stateName ||
                                        option.orgName ||
                                        option.label ||
                                        option
                                      }
                                    </option>
                                  ));
                                })()}
                              </Form.Select>
                            ) : field.type === 'date' ? (
                              <Form.Control
                                className={`form-input ${field.isDisabled ? 'disabled' : ''}`}
                                type={field.type}
                                name={field.name}
                                placeholder={field.placeholder}
                                value={
                                  field.type === 'date' && formData[field.name]
                                    ? /^\d{4}-\d{2}-\d{2}$/.test(formData[field.name])
                                      ? formData[field.name] // Use the value if it's already in YYYY-MM-DD format
                                      : new Date(formData[field.name].split('-').reverse().join('-'))
                                        .toISOString()
                                        .split('T')[0] // Convert if it's not in the correct format
                                    : ''
                                }
                                onChange={handleFormInputChange}
                                isInvalid={!!errors[field.name]}
                                disabled={field.isDisabled}
                                maxLength={field.maxLength}
                              />
                            ) : (
                              <Form.Control
                                className={`form-input ${field.isDisabled ? 'disabled' : ''}`}
                                type={field.type}
                                name={field.name}
                                placeholder={field.placeholder}
                                value={formData[field.name] || ''}
                                onChange={handleFormInputChange}
                                isInvalid={!!errors[field.name]}
                                disabled={field.isDisabled}
                                maxLength={field.maxLength}
                              />
                            )}
                            <Form.Control.Feedback type="invalid">
                              {errors[field.name]}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      )
                    );
                  })}
                </Row>
              ))}

              <div className="form-footer">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? t('loading') : 'Update Profile Information'}
                </button>
              </div>
            </Form>
          </Card.Body>
        </Card>
        <Card className="edit-profile-card" style={{
          opacity: !setProfileStatusFlag() ? 0.6 : 1,
          pointerEvents: !setProfileStatusFlag() ? "none" : "auto"
        }}>
          <Card.Body className="px-4 py-4">
            <Form>
              <fieldset disabled={!setProfileStatusFlag()}>
                {Object.entries(groupedfileFields).map(([row, fields]) => (
                  <Row key={row} className="mb-3">
                    {fields.map((field) => {
                      const isVisible = fieldStates[`${field.name}Visible`] !== false; // Default is true unless explicitly set to false
                      const isDisabled = fieldStates[`${field.name}Disabled`] === true;

                      return (
                        isVisible && (
                          <Col key={field.name} md={field.col || 6} sm={12}>
                            <Form.Group className="form-group">
                              <div className="d-flex align-items-center">
                                <Form.Label className="form-label mb-0">
                                  {t(field.label)}
                                  {field.required && <span className="text-danger">*</span>}
                                </Form.Label>
                                {field.infoTop && (
                                  <div className="field-top-info ms-3">
                                    <p className="text-muted mb-0">{field.infoTop.message}</p>
                                    {field.infoTop.link && (
                                      <a
                                        href={field.infoTop.link.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="d-block text-primary mt-1"
                                      >
                                        {field.infoTop.link.text}
                                      </a>
                                    )}
                                  </div>
                                )}
                              </div>
                              {field.type === "file" ? (
                                <div>
                                  <Row>
                                    <Col lg={6}>
                                      {/* {fileData[field.name]} */}
                                      <Form.Control
                                        className={`form-media ${field.isDisabled ? 'disabled' : ''}`}
                                        type="file"
                                        name={field.name}
                                        accept={field.accept.join(",")}
                                        onChange={handleFileChange}
                                        isInvalid={!!errors[field.name]}
                                        disabled={field.isDisabled}
                                      // value={fileData[field.name] || ''}
                                      />
                                    </Col>
                                    <Col lg={6}>
                                      <>
                                        {/* <button
                                        onClick={() => uploadFile(fileData["idproofpicpath"], formData["email"], formData["learnerUsername"], fileData["profilepicpath"])}
                                        type="button" class="btn btn-info m-2" disabled={PhotoLoading.isLoading ? "true" : ""} style={{ fontSize: '19px' }}>
                                        {PhotoLoading.isLoading ? (<><i class="fa fa-spinner fa-spin"></i></>) : (<><i class="fa fa-upload"></i> Upload</>)}
                                      </button> */}
                                        {
                                          field.label == "Upload User Photograph" && (<><OverlayTrigger overlay={<Tooltip id="tooltip-disabled">View Photograph</Tooltip>}><button
                                            onClick={() => viewPhoto(fileData["idproofpicpath"], formData["email"], formData["learnerUsername"], fileData["idproofpicpath"])}
                                            type="button" class="btn btn-info m-2" disabled={PhotoLoading.isLoading ? "true" : ""}>
                                            {PhotoLoading.isLoading ? (<><i class="fa fa-spinner fa-spin" style={{ fontSize: '24px' }}></i></>) : (<> <i class="fas fa-image fa-2x"></i></>)}
                                          </button></OverlayTrigger> Existing file: {fileData["profilepicname"]}</>)
                                        }
                                        {field.label == "Upload ID Proof" && (<><OverlayTrigger overlay={<Tooltip id="tooltip-disabled">View ID Proof</Tooltip>}><button
                                          onClick={() => viewID(fileData["idproofpicpath"], formData["email"])}
                                          type="button" class="btn btn-info m-2" disabled={IDLoading.isLoading ? "true" : ""}>
                                          {IDLoading.isLoading ? (<><i class="fa fa-spinner fa-spin" style={{ fontSize: '24px' }}></i></>) : (<><i class="fas fa-id-card fa-2x"></i></>)}
                                        </button></OverlayTrigger> Existing file: {fileData["idproofpicname"]}</>)}
                                        {field.label == "Upload Degree/Diploma Certificate" && (<><OverlayTrigger overlay={<Tooltip id="tooltip-disabled">View Certificate</Tooltip>}><button
                                          onClick={() => viewCertificate(fileData["certificatepath"], formData["email"])}
                                          type="button" class="btn btn-info m-2" disabled={CertificateLoading.isLoading ? "true" : ""}>
                                          {CertificateLoading.isLoading ? (<><i class="fa fa-spinner fa-spin" style={{ fontSize: '24px' }}></i></>) : (<><i class="fa fa-certificate fa-2x"></i></>)}
                                        </button></OverlayTrigger>Existing file: {fileData["certificatename"]}</>)}
                                      </>
                                    </Col>
                                  </Row>
                                </div>
                              ) : <></>}
                              <span style={{ color: "red" }}>
                                {errors[field.name]}
                              </span>
                              {field.infoBottom && (
                                <div className="field-bottom-info mt-2">
                                  <p className="text-muted mb-0">{field.infoBottom.message}</p>
                                  {field.infoBottom.link && (
                                    <a
                                      href={field.infoBottom.link.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="d-block text-primary mt-1"
                                    >
                                      {field.infoBottom.link.text}
                                    </a>
                                  )}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                        )
                      );
                    })}
                  </Row>
                ))}

                <div className="form-footer">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={handleFileSubmit}
                    disabled={loading}
                  >
                    {loading ? t('loading') : 'Update Profile Documents'}
                  </button>
                </div>
              </fieldset>
            </Form>

          </Card.Body>
        </Card>
        <div className='admin-approve-div'>
          <button
            className="btn btn-success admin-approve-button"
            onClick={handleAdminSubmit}
            disabled={submitLoading || !setProfileStatusFlag()}
          >
            {submitLoading ? t('loading') : 'Request Admin to Approve Profile'}
          </button>
        </div>
      </Container>
      <Modal centered show={getViewPhoto.show} onHide={() => ProfilePicHide()} backdrop="static" size="md">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter" style={{ alignContent: "center" }}>
            {t('photo')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <div style={{ textAlign: "center" }}>
            {(getViewPhoto.profilepicpath != null) ? (
              <TokenImageinModel path={getViewPhoto.profilepicpath} />
            ) : <>File not Available</>}
          </div>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "right" }}>
          <Button variant="secondary" onClick={() => ProfilePicHide()}>
            {t('cancel')}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal centered show={getViewID.show} onHide={() => IDCardHide()} backdrop="static" size="lg">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter" style={{ alignContent: "center" }}>
            {t('id_card')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <div style={{ textAlign: "center" }}>
            {(getViewID.idproofpicpath != null) ? (
              <TokenIDImageinModel path={getViewID.idproofpicpath} />
            ) : <>File not available</>}
          </div>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "right" }}>
          <Button variant="secondary" onClick={() => IDCardHide()}>
            {t('cancel')}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal centered show={getViewCertificate.show} onHide={() => CertificateHide()} backdrop="static" size="lg">
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter" style={{ alignContent: "center" }}>
            Certificate
          </Modal.Title>
        </Modal.Header>
        <Modal.Body >
          <div style={{ textAlign: "center" }}>
            {(getViewCertificate.certificatepath != null) ? (
              <TokenCertificateImageinModel path={getViewCertificate.certificatepath} />
            ) : <>File Not Available</>}
          </div>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "right" }}>
          <Button variant="secondary" onClick={() => CertificateHide()}>
            {t('cancel')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EditProfile;
